import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PDFExportModule } from '@progress/kendo-angular-pdf-export';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login.component';
import {
  AuthInterceptor,
  SortService,
  ChurchUnitsDataService,
  HousingDataService,
  UserService,
  ConfigService,
  AuthorizeGuard,
  StudentsDataService,
  SelectChurchUnitDialog,
  ConfirmDialog,
  MessageDialog,
  LeaderGuard,
  CampusWardsDataService,
  HasChangesGuard,
  CampusUnitsCommunicationsDataService,
  UnitAdminGuard,
  CampusUnitsMessageService,
  EmailService
} from './shared';
import { SharedModule } from './shared/shared.module';
import { UnitInformationModule } from './unit-information/unit-information.module';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { NavigationService } from './shared/services/navigation.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SelectChurchUnitDialog,
    ConfirmDialog,
    MessageDialog
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    UnitInformationModule,
    AppRoutingModule,
    PDFExportModule
  ],
  entryComponents: [SelectChurchUnitDialog, ConfirmDialog, MessageDialog],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    SelectivePreloadingStrategy,
    AuthorizeGuard,
    LeaderGuard,
    UnitAdminGuard,
    ConfigService,
    UserService,
    EmailService,
    HousingDataService,
    ChurchUnitsDataService,
    SortService,
    StudentsDataService,
    NavigationService,
    CampusWardsDataService,
    CampusUnitsMessageService,
    CampusUnitsCommunicationsDataService,
    HasChangesGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
